import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * PageLayout Component
 * Standardizes the layout, padding, and metadata for all pages.
 */
const PageLayout = ({
    children,
    title,
    fluid = false,
    className = "",
    withPadding = true
}) => {
    const location = useLocation();

    useEffect(() => {
        // Update document title
        document.title = title ? `${title} | SECURE360` : 'SECURE360 - Secure Your Digital Empire';

        // Scroll to top on page change
        window.scrollTo(0, 0);
    }, [title, location.pathname]);

    const containerClass = fluid ? "container-fluid" : "container";
    const paddingClass = withPadding ? "py-4" : "";

    return (
        <div className={`page-wrapper ${className} ${paddingClass}`}>
            <div className={containerClass}>
                {children}
            </div>
        </div>
    );
};

export default PageLayout;
